import { createSelector } from '@reduxjs/toolkit';

const selectMinerAccountsState = (state: any) => state.minerAccounts;

export const selectRecentSearches = createSelector(
  selectMinerAccountsState,
  (minerAccounts) => minerAccounts.recentSearches,
);

export const selectSelectedAccount = createSelector(
  selectMinerAccountsState,
  (minerAccounts) => ({
    selectedAccount: minerAccounts.selectedAccount,
    type: minerAccounts.type,
  }),
);
